import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const JerryFoxBanner = () => {
  return (
    <div className="bg-gradient-to-r from-[#C46829] to-[#8B4513] text-white py-4 px-4">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center text-center gap-4">
        <div className="flex-1">
          <h3 className="font-montserrat font-bold text-lg sm:text-xl mb-1">
            🏛️ Help Honor Jerry Fox - Brooklyn's Heroic Cat!
          </h3>
          <p className="text-white/90 text-sm sm:text-base">
            Sign the petition to commemorate Brooklyn's feline hero with a plaque at Borough Hall
          </p>
        </div>
        <Link to="/petition-jerry-fox">
          <Button 
            variant="secondary" 
            size="lg"
            className="bg-white text-[#C46829] hover:bg-white/90 font-montserrat font-semibold"
          >
            <ExternalLink className="mr-2 h-4 w-4" />
            Sign the Petition
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default JerryFoxBanner;